import React from 'react';
import { NavLink } from 'react-router-dom';

const categories = [
  { label: 'LEDBARY', path: '/produkty/ledbary' },
  { label: 'ZDROJE', path: '/produkty/zdroje' }
];

const ProductCategoryTabs = () => {
  return (
    <nav
      aria-label="Kategorie produktů"
      className="flex flex-wrap justify-center gap-2 mb-12"
    >
      {categories.map((category) => (
        <NavLink
          key={category.path}
          to={category.path}
          className={({ isActive }) => (
            `px-6 py-3 rounded-full text-[11px] font-bold uppercase tracking-widest transition-all ${
              isActive
                ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/20'
                : 'bg-white text-gray-500 border border-gray-200 hover:border-blue-600 hover:text-blue-600'
            }`
          )}
        >
          {category.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default ProductCategoryTabs;